<template>
    <div>
        <v-dialog v-model="dialogoEditar" max-width="800px" persistent>
            <v-card>
                <!-- Overlay de carregamento que aparece durante a operação -->
                <v-overlay :value="isLoading">
                    <v-progress-circular indeterminate size="64"></v-progress-circular>
                </v-overlay>
                <!-- Título do pop-up -->
                <v-card-title class="tituloPopUp justify-center">Editar Dados</v-card-title>
                <v-card-text>
                    
                    <v-container>
                        <v-row>
                            <v-col cols="12">
                                <!-- Exibição das permissões -->
                                <div class="permissoes-inline">
                                    <div v-for="(permissao, index) in permissoesAll" :key="index"
                                        class="permissao-item">
                                        <!-- Exibição do nível e descrição da permissão -->
                                        <span class="nivel">{{ permissao.nivel }}</span>
                                        <span class="descricao">- {{ permissao.descricao }}</span>
                                    </div>
                                </div>
                            </v-col>
                        </v-row>
                    </v-container>

                    <!-- Formulário de edição -->
                    <v-form ref="form" v-model="valid" lazy-validation>
                        <v-container>
                            <v-row>
                                <!-- Campo de descrição -->
                                <v-col cols="4">
                                    <v-text-field label="Descrição: " v-model="dados.descricao"></v-text-field>
                                </v-col>
                                <!-- Campo de "Atualizado por", que é desabilitado -->
                                <v-col cols="4">
                                    <v-text-field :disabled="true" label="Atualizado por: "
                                        v-model="dados.modifiedBy"></v-text-field>
                                </v-col>
                                <!-- Campo de "Data Atualização", que é desabilitado -->
                                <v-col cols="4">
                                    <v-text-field :disabled="true" label="Data Atualização:"
                                        v-model="dados.modifiedOn"></v-text-field>
                                </v-col>
                                <!-- Campo para permissões, com validação -->
                                <v-col cols="4">
                                    <v-text-field label="Permissões:" :rules="[validateFormat]" @input="sanitizeInput"
                                        v-model="dados.niveis"></v-text-field>
                                </v-col>
                                <!-- Campo para seleção de "Função nova" -->
                                <v-col cols="4">
                                    <div class="tpaCombox">
                                        <v-combobox v-model="isNovoSelected" label="Função nova: " item-value="id"
                                            item-text="descricao" :items="opcoes" return-object>
                                        </v-combobox>
                                    </div>
                                </v-col>
                                <!-- Campo para verificar licença -->
                                <v-col cols="4">
                                    <div class="tpaCombox">
                                        <v-combobox v-model="validarSelected" label="Verificar licença: " item-value="id"
                                            item-text="descricao" :items="opcoes" return-object>
                                        </v-combobox>
                                    </div>
                                </v-col>
                                <!-- Campo para status -->
                                <v-col cols="4">
                                    <div class="tpaCombox">
                                        <v-combobox v-model="statusSelected" label="Status: " item-value="id"
                                            item-text="descricao" :items="statusOpcoes" return-object>
                                        </v-combobox>
                                    </div>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-form>
                </v-card-text>
                <!-- Ações do pop-up: botões de fechar e salvar -->
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="hideCard(false)">Fechar</v-btn>
                    <v-btn color="green darken-1" :disabled="!valid" @click="Salvar()"
                        style="color: white">Atualizar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import Swal from "sweetalert2";
import axios from "@/plugins/axios";
const ls = require("local-storage");
import ItensMenuService from "../../services/ItensMenuService";
import ItensMenuUtilitarios from "../../utilitarios/ItensMenuUtilitarios";

export default {
    props: ["dados"], // Recebe os dados da tabela que serão editados
    data: () => ({
        isLoading: false,
        dialogoEditar: true,
        valid: true,
        isNovoSelected: null,
        statusSelected: null,
        validarSelected: null,
        opcoes: [
            { id: 1, descricao: 'Sim' },
            { id: 0, descricao: 'Não' }
        ],
        statusOpcoes: [
            { id: 1, descricao: 'Activo' },
            { id: 0, descricao: 'Desativado' }
        ],
        permissoesAll: []
    }),

    computed: {
        // Obtém o nome do usuário logado da local storage
        usuario() {
            return ls.get('nomeUsuario');
        }
    },

    created() {
        // Inicializa as opções selecionadas com base nos dados recebidos
        this.isNovoSelected = this.opcoes.find(o => o.id == this.dados.novo) || null;
        this.validarSelected = this.opcoes.find(o => o.id == this.dados.validarLicenca) || null;
        this.statusSelected = this.statusOpcoes.find(s => s.id == this.dados.status) || null;
        this.carregarPermissoes(); // Carrega as permissões ao criar o componente
    },

    methods: {
        // Função para carregar as permissões a partir de uma API
        async carregarPermissoes() {
            try {
                const response = await axios.get('/ObterPermissoesLista');
                this.permissoesAll = response.data || [];
            } catch (error) {
                Swal.fire('Erro', `Ocorreu um erro ao carregar as permissões!`, 'error');
            }
        },

        // Validação para garantir que o formato dos níveis de permissão seja correto
        validateFormat(value) {
            const regex = /^(\d+)(,\d+)*$/; // Aceita números separados por vírgulas
            return regex.test(value) || "Insira números separados por vírgulas corretamente.";
        },

        // Função para sanitizar a entrada e remover caracteres inválidos
        sanitizeInput() {
            const sanitized = this.dados.niveis
                .replace(/[^0-9,]/g, "") // Remove caracteres não numéricos e que não sejam vírgulas
                .replace(/,{2,}/g, ",") // Remove vírgulas consecutivas
                .replace(/^,|,$/g, ""); // Remove vírgulas no início ou no final
            this.dados.niveis = sanitized;
        },

        // Função para fechar o pop-up e resetar os campos selecionados
        hideCard(bool) {
            this.dialogoEditar = false;
            this.isNovoSelected = null;
            this.validarSelected = null;
            this.statusSelected = null;
            this.emite(bool);
        },

        // Emite um evento para o componente pai notificando o fechamento do pop-up
        emite(boolean) {
            this.$emit("fecharCardEditar", boolean);
        },

        // Função para salvar as alterações
        async Salvar() {
            this.isLoading = true;
            try {
                let params = {
                    id: this.dados.id,
                    descricao: this.dados.descricao,
                    permissoes: this.dados.niveis,
                    novo: this.isNovoSelected.id,
                    licenca: this.validarSelected.id,
                    status: this.statusSelected.id,
                    autor: this.usuario
                };

                // Chama o serviço para atualizar o item no menu
                let result = await ItensMenuService.updateItemMenu(params);
                if (result == 200) {
                    Swal.fire('Sucesso', 'Dados actualizados com sucesso!', 'success');
                    ItensMenuUtilitarios.carregarItensMenu(); // Atualiza os itens do menu
                    this.hideCard(true); // Fecha o pop-up
                } else {
                    Swal.fire('Erro', 'Ocorreu um erro ao realizar a operação!', 'error');
                }
            } catch (error) {
                Swal.fire('Erro', `Ocorreu um erro ao realizar a operação!`, 'error');
            } finally {
                this.isLoading = false;
            }
        }
    }
};
</script>

<style scoped>
/* Estilos específicos para o título do pop-up */
.tituloPopUp {
    font-size: 18px;
    font-weight: 500;
    text-align: center;
}

/* Estilos para as permissões exibidas em linha */
.permissoes-inline {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    margin-bottom: 10px;
}

.permissao-item {
    display: inline-block;
    padding: 5px;
    border: 1px solid #ddd;
    border-radius: 5px;
    background-color: #f7f7f7;
}

.nivel {
    font-weight: bold;
}

/* Estilos para os campos do combo box */
.tpaCombox .v-input {
    margin-bottom: 10px;
}
</style>
